import isMobile from 'ismobilejs'

export function getDevice() {
    return isMobile().phone
        ? 'phone'
        : isMobile().tablet
            ? 'tablet'
            : 'desktop'
}